<template lang="pug">
  #app
    nav-bar
    router-view
</template>

<script>
import NavBar from '@/components/NavBar.vue';

export default {
  name: 'App',
  components: {
    NavBar,
  },
  created() {
    this.$store.dispatch('FETCH_DATA');
  },
};
</script>


<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.clickable {
  cursor: pointer;
}
.disabled {
  pointer-events: none;
}
.ui.vertical.segment {
  border-bottom: none;
}
</style>
